import React from 'react';
import PublicLayout from '../../components/public/PublicLayout';
import PageHero from '../../components/public/PageHero';
import Accordion from '../../components/public/Accordion';
import { usePageMeta } from '../../publicSite/usePageMeta';

export default function Faq() {
  usePageMeta('FAQ | School of Shem', 'Frequently asked questions about School of Shem cohorts and admissions.');

  const items = [
    { key: 'cohorts', title: 'How do cohorts work?', body: 'Cohorts run on a structured weekly rhythm with live sessions, assignments, and accountability.' },
    { key: 'apply', title: 'How do I apply?', body: 'Complete the application form and our team will review your submission.' },
    { key: 'access', title: 'When is access granted?', body: 'Access is granted once your registration is reviewed and confirmed.' },
    { key: 'login', title: 'How do I login?', body: 'Use the login link in the header to access your portal credentials.' },
    { key: 'payment', title: 'What are payment options?', body: 'We offer structured payment options based on cohort requirements.' },
    { key: 'support', title: 'What support is available?', body: 'Mentorship, feedback, and technical support are provided throughout the cohort.' },
    { key: 'schedule', title: 'What is the weekly schedule?', body: 'You will receive a cohort calendar with live sessions and due dates.' },
    { key: 'resources', title: 'How do I access resources?', body: 'Resources are available in the student portal once you are enrolled.' },
    { key: 'community', title: 'Is there a community?', body: 'Yes. We facilitate group discussions, community updates, and accountability.' },
    { key: 'transfer', title: 'Can I transfer between programs?', body: 'Transfers are reviewed case by case by the admin team.' },
    { key: 'cert', title: 'Do I get a certificate?', body: 'Completion certificates are issued after finishing program requirements.' },
    { key: 'updates', title: 'How do I get updates?', body: 'Sign up for updates in the Contact menu to receive announcements.' }
  ];

  return (
    <PublicLayout>
      <PageHero
        eyebrow="FAQ"
        title="Frequently Asked Questions"
        subtitle="Quick answers for admissions, cohorts, and portal access."
      />
      <section className="ps-section">
        <div className="ps-section-inner">
          <Accordion items={items} />
        </div>
      </section>
    </PublicLayout>
  );
}
